/**
 * An Abrechnungsbeauftragung's state (#1613).
 *
 * ⚠ **Derived, never stored.** There is no `state` column. The state falls out
 * of the record's fields and the Berlin calendar day —
 * `deriveAbrechnungsbeauftragungState` is the only place that names it. A stored
 * column would have to be rewritten by somebody on the day `effectiveFrom` is
 * reached; without such a somebody *vereinbart* would stand on a Beauftragung
 * that has long been billed under.
 *
 * The values are English, the glossary term stands beside them (`CONTEXT.md`,
 * section *Abrechnungsbeauftragung*) and is what the UI shows.
 */
export var AbrechnungsbeauftragungState;
(function (AbrechnungsbeauftragungState) {
    /** *entwurf* — accepted, but Therame has not identified the accepting person yet. */
    AbrechnungsbeauftragungState["DRAFT"] = "DRAFT";
    /** *vereinbart* — accepted and identified, the beginning still lies ahead. */
    AbrechnungsbeauftragungState["AGREED"] = "AGREED";
    /** *wirksam* — Therame is this Standort's Absender. */
    AbrechnungsbeauftragungState["EFFECTIVE"] = "EFFECTIVE";
    /** *gekündigt* — an end is set and not yet reached; in force until then. */
    AbrechnungsbeauftragungState["TERMINATED"] = "TERMINATED";
    /** *beendet* — the end lies behind us. Only then may a new record come into being. */
    AbrechnungsbeauftragungState["ENDED"] = "ENDED";
})(AbrechnungsbeauftragungState || (AbrechnungsbeauftragungState = {}));
/**
 * *In force* means *wirksam* or *gekündigt* (`CONTEXT.md`).
 *
 * ⚠ A terminated Beauftragung is just as much the Absender up to its last day as
 * an effective one. Checking only `EFFECTIVE` here would push a practice back to
 * Übergabe on the day of termination — and a practice's route never changes
 * without it.
 */
export function isAbrechnungsbeauftragungInEffect(state) {
    return (state === AbrechnungsbeauftragungState.EFFECTIVE ||
        state === AbrechnungsbeauftragungState.TERMINATED);
}
//# sourceMappingURL=abrechnungsbeauftragung-state.enum.js.map